/**
 * COA Certificate Section JavaScript
 * Handles lightbox and interactive features for PDF certificates
 */

class COACertificate {
  constructor(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.lightbox = document.getElementById(`coa-lightbox-${this.sectionId}`);
    
    this.init();
  }
  
  init() {
    this.bindEvents();
  }
  
  bindEvents() {
    // Certificate PDF container double-click to open lightbox
    const certificateContainer = this.section.querySelector('.coa-certificate-pdf-container');
    if (certificateContainer) {
      certificateContainer.addEventListener('dblclick', () => this.openLightbox());
    }
    
    // View button click
    const viewButton = this.section.querySelector('.coa-button-view');
    if (viewButton) {
      viewButton.addEventListener('click', () => this.openLightbox());
    }
    
    if (!this.lightbox) return;
    
    // Close button
    const closeBtn = this.lightbox.querySelector('.coa-lightbox-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeLightbox());
    }
    
    // Backdrop click
    const backdrop = this.lightbox.querySelector('.coa-lightbox-backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', () => this.closeLightbox());
    }
    
    // Keyboard controls
    document.addEventListener('keydown', (e) => this.handleKeyboard(e));
  }
  
  openLightbox() {
    if (!this.lightbox) return;
    
    const certificatePdf = this.section.querySelector('.coa-certificate-pdf');
    const lightboxPdfWrapper = this.lightbox.querySelector('.coa-lightbox-pdf-wrapper');
    
    if (certificatePdf && lightboxPdfWrapper) {
      const pdfUrl = certificatePdf.dataset.certificateUrl;
      
      // Validate PDF URL
      if (!pdfUrl || pdfUrl === '') {
        console.error('Certificate PDF URL is missing');
        return;
      }
      
      // Create iframe element dynamically
      let lightboxPdf = lightboxPdfWrapper.querySelector('.coa-lightbox-pdf');
      if (!lightboxPdf) {
        lightboxPdf = document.createElement('iframe');
        lightboxPdf.className = 'coa-lightbox-pdf';
        lightboxPdf.title = 'Certificate of Analysis';
        lightboxPdfWrapper.appendChild(lightboxPdf);
      }
      
      // Load PDF in lightbox without navigation panes
      lightboxPdf.src = pdfUrl + '#toolbar=1&navpanes=0&scrollbar=1&view=FitH&zoom=page-fit';
    }
    
    this.lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  closeLightbox() {
    if (!this.lightbox) return;
    
    this.lightbox.classList.remove('active');
    document.body.style.overflow = '';
    
    // Clear PDF iframe to stop loading
    const lightboxPdf = this.lightbox.querySelector('.coa-lightbox-pdf');
    if (lightboxPdf) {
      lightboxPdf.src = '';
    }
  }
  
  handleKeyboard(e) {
    if (!this.lightbox?.classList.contains('active')) return;
    
    if (e.key === 'Escape') {
      this.closeLightbox();
    }
  }
}

// Initialize all COA certificate sections
document.addEventListener('DOMContentLoaded', () => {
  const coaSections = document.querySelectorAll('.coa-certificate-section');
  coaSections.forEach(section => {
    new COACertificate(section);
  });
});

// Re-initialize if Shopify section is refreshed (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.coa-certificate-section');
    if (section) {
      new COACertificate(section);
    }
  });
}